package com.essntl.uikit.components.icons

import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalContentColor
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.esIconPainterResource

@Composable
fun EsIcon(
    res: String,
    size: EsIconSize,
    isSvg: Boolean = false,
    tint: Color = LocalContentColor.current,
    modifier: Modifier = Modifier,
) {
    Icon(
        painter = esIconPainterResource(res, isSvg),
        contentDescription = null,
        tint = tint,
        modifier = modifier.size(size.size)
    )
}

enum class EsIconSize {
    Large, Medium, Small;

    val size get() = when(this) {
        Large -> EsConstants.LargeIconSize
        Medium -> EsConstants.MediumIconSize
        Small -> EsConstants.SmallIconSize
    }
}